import styles from './index.module.sass';
import { Nav } from '@@/buyer-account/components/nav';
import { WarningVerification } from '@@/buyer-account/components/warning-verification';
import { ReactNode } from 'react';

export const PageTemplate = ({
  children,
  navItems,
}: {
  children: ReactNode;
  navItems: { label: string; to: string; active: boolean }[];
}) => {
  return (
    <div className={styles.root}>
      <Nav items={navItems} />
      <div className={styles.pageContent}>
        { PUBLIC_MODE === 'development' && <WarningVerification />}
        {children}
      </div>
    </div>
  );
};
